// eslint-disable-next-line import/prefer-default-export

import Notification from "./components/Notification/Notification";

export const handleKeyPress =
  (callback, ...args) =>
  (event) => {
    if (event.key === "Enter") {
      callback(...args);
    }
  };

export const notificationErrors = (errors) => {
  const createErrors = Object.keys(errors).map((errorMsg) => `${errors[errorMsg]}\n`);
  return createErrors.join("");
};

export const debounce = (func, wait) => {
  let timeout;

  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

const resourceTypes = {
  "6A6B280C-B682-47BD-A672-7F5763192251": "Profile",
  "A122F74F-DA8A-44D6-8CE3-BF03045E2CB1": "ADS",
  "68502F5B-ED7F-41BB-903D-EEA1FE643DAC": "Engine Config",
  "1C0966AA-F43A-4DE9-A62E-5830A4A96466": "Project Template",
  "54802874-F90C-4EC2-97F6-980A1E60B38D": "Query Catalog",
};

export const getResourceTypeDisplayName = (guid) => {
  const upperGuid = guid?.toUpperCase();
  return resourceTypes[upperGuid] || "Unknown Type";
};

export const notifyMultipleErrors = (errors) => {
  const createErrors = Object.keys(errors).map((errorMsg) => `${errors[errorMsg]}`);
  createErrors.forEach((error) => Notification(error, "error"));
};

export const getLengthOfFilename = (name) => {
  const fileNameWithExtension = name;
  const split = fileNameWithExtension.split(".");
  const fileNamewithoutextension = split[0];
  return fileNamewithoutextension.length;
};
